import StoryPage from './StoryPage'

export default [{
	path: '/:type/:id',
	component: StoryPage
}]


// WEBPACK FOOTER //
// ./src/pages/story/storyRoutes.js